export default "__VITE_ASSET__DiOLvO31__"